import { isUrlExternal } from '@/helpers/urlHelper'
import { isNativeApp, sendMessageToNative } from '@red-ui/bridge'
import { GestureResponderEvent } from 'react-native'

type EventType = Event | React.MouseEvent | React.KeyboardEvent | React.FormEvent | GestureResponderEvent

export const handleExternalButtonLink = <E extends EventType>(url: string, event?: E) => {
  if (isNativeApp() && isUrlExternal(url)) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault()
    }
    sendMessageToNative({
      type: 'external_link',
      payload: { url },
    })
  } else {
    window.location.href = url
  }
}

export const handleInAppLink = <E extends EventType>(path: string, e?: E) => {
  if (!isNativeApp()) return

  if (e && typeof e.preventDefault === 'function') {
    e.preventDefault()
  }

  const type = isUrlExternal(path) ? 'external_link' : 'internal_link'
  if (type === 'external_link') {
    sendMessageToNative({
      type,
      payload: { url: path },
    })
  } else {
    sendMessageToNative({
      type,
      payload: { path },
    })
  }
}
